export enum routes {
  //Dashboard Module
  DASHBOARD = 'dashboard',
  CUSTOMER = 'customer',
  TYPOGRAPHY = '/typography',
  TABLES = '/tables',
  NOTIFICATION = '/notification',
  UI_ELEMENTS_ICONS = '/ui/icons',
  UI_ELEMENTS_CHARTS = '/ui/charts',
  UI_ELEMENTS_MAP = '/ui/map',
  LOGIN = 'https://qa-login.companion-cams.com/login?client_id=5lfa3lldn1eu6106f1qcr3hj3c&response_type=token&scope=email+openid+phone&redirect_uri=http%3A%2F%2Flocalhost%3A4200%2Fdashboard'
}
